<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Add participant'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">
            <mat-form-field appearance="outline" fxFlex="80">
                <mat-label>{{'Customer'|translate}}</mat-label>
                <input type="text"
                       placeholder="{{ 'Customer'|translate }}"
                       matInput
                       formControlName="customer"
                       [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option [value]="customer" *ngFor="let customer of filteredOptions|async">
                        {{customer.firstName}} {{customer.lastName}}; {{customer.phone?customer.phone:''}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error>{{'Customer is required!'|translate}}</mat-error>
            </mat-form-field>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(form)"
                aria-label="Confirm">
            {{'Add'|translate}}
        </button>

    </div>
</div>
